// app-shell-work-context-R05/R07; backend-contracts-work-context-api-R02/R03.
import { httpClient } from './client';
import { createFeatureId, createProjectId, type TFeatureId, type TProjectId } from '@/shared/types';
import { assertObject, assertBoolean, assertEntityIdOrNull } from '@/shared/types/validation';

export interface IWorkContextRequest {
  readonly targetOperation: string;
  readonly projectId?: string;
  readonly featureId?: string;
}
export interface IWorkContext {
  readonly projectId: TProjectId | null;
  readonly featureId: TFeatureId | null;
  readonly featureReplaced: boolean;
}
export async function resolveWorkContext(request: IWorkContextRequest): Promise<IWorkContext> {
  const response = await httpClient.get<unknown>('/work-context', { params: request });
  const data = assertObject(response.data, 'workContext');
  const projectId = assertEntityIdOrNull(data['projectId'], 'workContext.projectId');
  const featureId = assertEntityIdOrNull(data['featureId'], 'workContext.featureId');
  if (projectId === null && featureId !== null) throw new Error('Feature without project');
  return {
    projectId: projectId === null ? null : createProjectId(projectId),
    featureId: featureId === null ? null : createFeatureId(featureId),
    featureReplaced: assertBoolean(data['featureReplaced'], 'workContext.featureReplaced'),
  };
}
